export default __webpack_public_path__ + "static/banner-two-1a191fb468ef040378afbb6a88ef9c6b.jpg";